import Tag from "./Tag";
export default Tag;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/Tag/index.tsx